import 'core-js/es';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'allsettled-polyfill';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { getScript } from '@/common/utils/get-script';
import { getCss } from '@/common/utils/get-css';
import { ConfigProvider } from 'antd';
import store from '@/store/store';
import { Provider } from 'react-redux';
import zhCN from 'antd/es/locale/zh_CN';
import App from './app';
import dayjs from 'dayjs';
import { AliveScope } from 'react-activation';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import 'dayjs/locale/zh-cn';
import './global.less';
import { ignoreErrors } from './common/ignore/sentryError';
import { ErrorBoundary } from 'react-error-boundary';

dayjs.locale('zh-cn');
/** react-activation 对 Context 的破坏性影响
 * https://github.com/CJY0208/react-activation/blob/master/README_CN.md
 * 如果run serve报错，查看 https://github.com/react-dnd/react-dnd/issues/3423
 */
import { autoFixContext } from 'react-activation';
import { aMapServiceHost } from './common/utils/map';
import { getCookie, getStorage } from '@lhb/cache';
// import V2Empty from '@/common/components/Data/V2Empty';
// import { getStorage, setStorage } from '@lhb/cache';
autoFixContext(
  [require('react/jsx-runtime'), 'jsx', 'jsxs', 'jsxDEV'],
  [require('react/jsx-dev-runtime'), 'jsx', 'jsxs', 'jsxDEV']
);
// qiankun
// import start from '@/common/qiankun';

const serviceHost = aMapServiceHost;

window.getScript = getScript;
window.getCss = getCss;
// https://lbs.amap.com/api/javascript-api-v2/guide/abc/load
window._AMapSecurityConfig = {
  serviceHost,
};

// 接入sentry，预演、线上环境接入
if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    // dsn: 'https://aa500217ac164b6a83e99b053fb86714@sentry.lanhanba.com/11',
    integrations: [
      new BrowserTracing({
        tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // 忽略无意义的错误
    ignoreErrors,
    beforeSend(event: any) {
    // console.log(`event`, event);
    // console.log(`hint`, hint);
      const tenantId = getCookie('tenantId');
      const employeeId = getCookie('employeeId');
      const user = getCookie('flow_token');
      if (event && event.extra) {
        event.extra.userInfo = {
          tenantId,
          employeeId,
          // 上报的是token，这里不用token是因为sentry把token当成了关键词，会把一切包含于token的转换为不可见的字符
          user,
          des: '为方便前端快速排查问题，额外上报的信息',
        };
      }
      return event;
    // return null 会将此次上报丢弃
    }
  });
}
// 本地测试完成后，记得通过NODE_ENV判断将 本地启动环境屏蔽
if (process.env.NODE_ENV !== 'development') {
  window.LHBbigdata.init({
    isSpa: true,
    cha_type: 'location-pc',
    // 在cookie或者localstorage里抓取对应的参数放入到外层数据里
    extendOuterConfig: [
      // 要求不上报token，说不安全
      // {
      //   key: 'token',
      //   target: 'flow_token',
      // },
      // 根据抓取的目标参数命名不同，上报数据等同于上面
      {
        key: 'user_id',
        target: 'employeeId'
      }, {
        key: 'tenant_id',
        target: 'tenantId'
      }
    ],
    si: 'pc',
    sendFunc: function(params, config) {
      try {
        window.LHBbigdata.xhrTool.send(process.env.NODE_TYPE === 'pe' ? config.logPathPro : config.logPathPre, params);
      } catch (err) {}
    }
  });
  // 线上环境不再提示接口请求被取消
  window.addEventListener('unhandledrejection', function(event) {
    if (event?.reason?.message?.indexOf('您取消了请求') > -1) {
      event.preventDefault();
    }
  });
} else {
  // 本地开发环境过滤 ResizeObserver loop limit exceeded 报错
  window.addEventListener('error', (err) => {
    try {
      if (err.type === 'error') {
        // 微应用需要设置 (container || document)
        const iframe: any = document.querySelector('#webpack-dev-server-client-overlay');
        if (err.message.indexOf('ResizeObserver loop limit exceeded') > -1 || err.message.indexOf('ResizeObserver loop completed with undelivered notifications') > -1) {
          iframe.contentWindow.document.querySelector('#webpack-dev-server-client-overlay-div button').click();
        }
      }
    } catch (_) {}
  });
}
const fallbackRender = ({
  error
}) => {
  const { message } = error;
  // 页面长时间停留期间，有新的发布，因为内容/权限等修改，打包后的js文件hash值变化
  if (message.includes('ChunkLoadError') || message.includes('Loading chunk') || message.includes('Loading CSS chunk')) {
    // 检查chunk加载失败次数
    // const chunkErrorCount = getStorage('CHUNK_LOAD_ERROR_COUNT');
    // 最多重试三次
    // if (!chunkErrorCount || +chunkErrorCount < 3) {
    // setStorage('CHUNK_LOAD_ERROR_COUNT', +chunkErrorCount ? +chunkErrorCount + 1 : 1);
    window.location.reload();
    // }
  }
  // `前方正在施工中~${error}`
  // const curUrl = window.location.href;
  const technicalMobile = getStorage('technicalMobile');
  return <div className='error-boundary-container'>
    {/* <V2Empty centerInBlock customTip={<>
      <div>前方正在施工中~</div>
      <div>{curUrl}</div>
      <div>{message}</div>
    </>}/> */}
    <div className='error-boundary-content'>
      <div className='error-boundary-img-box'>
        <img
          src='https://staticres.linhuiba.com/project-custom/locationpc/fail_loc.png'
          width='100%'
          height='100%'/>
      </div>
      <div className='ml-20'>
        <div className='c-222 fs-18 bold'>
          哎呀！系统似乎出现了些问题，请尝试以下操作：
        </div>
        <div className='c-666 fs-16 mt-14'>
          <div>
            1、刷新页面。
          </div>
          <div>
            2、如果问题仍然存在，请联系您的客户经理。
          </div>
          {
            technicalMobile ? <div>
            联系方式：{technicalMobile}
            </div> : <></>
          }
        </div>
      </div>
    </div>
  </div>;
};

ReactDOM.render(
  <ErrorBoundary
    fallbackRender={fallbackRender}
  >
    <BrowserRouter>
      <AliveScope>
        <Provider store={store}>
          <ConfigProvider locale={zhCN}>
            <App />
          </ConfigProvider>
        </Provider>
      </AliveScope>
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById('root')
);

// 启动 qiankun
// start();


